import React from "react";
import {
  CardBody,
  Row,
  Col,
  ModalBody,
} from "reactstrap";
// import { history } from '_helpers';

// import Datetime from "react-datetime";
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
// import * as moment from 'moment';
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";



class SubeventHelpModal extends React.Component {
  constructor(props) {
    super(props);
    console.log("CreateUpdateLocation constructor()", props)
    this.state = {
    };

  }



  componentDidMount() {
  }

  render() {
    const { fees } = this.props
    const { fetchingFees } = fees
    // let remit = num * ticket.price
    // let lvFee = remit * (liveNyteTicketPercentage/100) +
    //             num   * liveNyteTicketFlatFee
    // let stripeFee = (remit + lvFee + stripeFlatFee) / (1 - (stripePercentage/100)) - remit - lvFee
    // console.log("num", num, "remit", remit, "lvFee", lvFee, "stripeFee", stripeFee)
    console.log("SubeventHelpModal: render", this.state)


    if (fetchingFees === true) {
      return (
        <div>Loading</div>
      )
    }
    return (
      <ModalBody>
        <Row>
          <Col xs={12}>
            <p className="text-left px-2 py-2">
              <h3 className="text-uppercase mb-1">General</h3>

              <div className="title mb-2 text-muted">
                A time block is a period during your event when you want to book talent.
              </div>

              <ul className="modal-list">
                <li>
                  Choose the <b>start and end times</b> for your time block.
                </li>
                <li>
                  Specify the <b>types of talent</b> you need and the quantity for each (e.g., 2 comedians, 3 musicians, 1 actor, 4 models, etc.).
                </li>
                <li>
                  Send <b>offers</b> to talent you’re interested in booking. LiveNyte ensures talent is never overbooked, and you’ll only book up to the number you’ve specified.
                </li>
              </ul>
            </p>
          </Col>
        </Row>
      </ModalBody>
    );
  }
}

function mapStateToProps(state) {
  const { feesData } = state;
  const { fees, fetchingFees } = feesData;
  return {
    fees, fetchingFees
  };
}

const connectedSubeventHelpModal = connect(mapStateToProps)(SubeventHelpModal);
export { connectedSubeventHelpModal as SubeventHelpModal }; 